<div class="clare-list">
    <mat-card flex layout>
        <mat-card-content>
            <div *ngIf="!shouldHideSearch" #search class="tbl-filter">
                <mat-icon inline id="search-prefix" class="fp-icon-search" fxFlex="0 1 auto"></mat-icon>
                <clare-search
                    [placeholder]="placeholder"
                    fxFlex="1 1"
                    [initialValue]="initialQueryString"
                    (searchDataHandler)="onDataSearch($event)"
                ></clare-search>
            </div>
            <div class="list-container">
                <div class="headers">
                    <p *ngFor="let column of columnArray">{{ columns[column] }}</p>
                </div>
                <div class="list-group-viewport">
                    <ul class="list-group">
                        <li *ngFor="let item of source" class="list-group-item" (click)="onEditClick(item.id)">
                            <ng-container *ngFor="let column of listStructure; let i = index">
                                <div *ngIf="column.length > 1; else oneLine">
                                    <div *ngFor="let line of column; let j = index">
                                        <clare-status-indicator
                                            *ngIf="i === 0 && j === 0 && item['onlineStatus']"
                                            [status]="[null, item['onlineStatus'][1]]"
                                        ></clare-status-indicator>
                                        <span [ngClass]="{ name: i === 0 && j === 0 }">{{ item[line] }}</span>
                                    </div>
                                </div>
                                <ng-template #oneLine>
                                    <div>
                                        {{ item[column[0]] || "-" }}
                                    </div>
                                </ng-template>
                            </ng-container>
                        </li>
                    </ul>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
